import {defineMessages} from 'react-intl';

export default defineMessages({
  accept: {
    defaultMessage: 'Agree',
    id: 'Modals.TermsOfService.Accept',
  },
});
